/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from 'react';
import Instrument from '../../classes/Instrument';
import Quote from '../../classes/Quote';
import store from '../../states/Store';
import QuoteRow from './QuoteRow';
import InputBoolean from '../blocks/InputBoolean';


interface IProps {
  legend: string,
  headers: string[],
  properties: string[],
  quotes: Quote[],
  isAlignLeft: boolean[],
  isInput: boolean[],
}

export default function QuoteTable(props: IProps) {
  const [trigger, setTrigger] = useState(1); // Trigger update in React component

  const getHeaders = (legend: string, quotes: Quote[], headers: string[], isAlignLeft: boolean[]) =>
  (<tr>{headers.map((header: string, index: number) => {
    return header !== ''
      ? (<th key={header} className={`text-align-${isAlignLeft[index] ? 'left' : 'right'}`}>{header}</th>)
      : (<td><InputBoolean
        id={`toggle-${legend}`}
        callBack={(value: boolean) => {
          quotes.forEach((quote: Quote) => Quote.setProperty(quote, 'Enabled', value));
          setTrigger(-trigger);
        }}
        value={quotes.reduce((result, quote) => result || quote.Enabled, false)}
      /></td>);
  })}</tr>);

  const getRows = (quotes: Quote[], properties: string[], isAlignLeft: boolean[], isInput: boolean[]) =>
    quotes.map((quote: Quote) => {
      quote.Enabled = store.Exclusion.SyntheticInstruments.getValue().indexOf(Instrument.serialize(quote)) === -1;
      return (<QuoteRow
        key={Quote.serialize(quote)}
        id={Quote.serialize(quote)}
        quote={quote}
        properties={properties}
        isAlignLeft={isAlignLeft}
        isInput={isInput}
      />);
    });

  return (
    <form>
      <fieldset>
        <legend>
          {props.legend}
        </legend>
        <table>
          <tbody>
            {getHeaders(props.legend, props.quotes, props.headers, props.isAlignLeft)}
            {getRows(props.quotes, props.properties, props.isAlignLeft, props.isInput)}
          </tbody>
        </table>
      </fieldset>
    </form>);
}